/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import validate from "validate.js";
import clsx from "clsx";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { Button, TextField } from "@material-ui/core";
import styles from "./styles";
import { useTranslation } from "react-i18next";

const schema = {
  userName: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      minimum: 3,
      tooShort: "needs to have %{count} words or more",
    },
  },
  password: {
    presence: { allowEmpty: false, message: "is required" },
  },
};

function Login({ className, onSubmit, onForgot, option, ...rest }) {
  const classes = styles();
  const { t } = useTranslation();
  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  });

  const handleChange = (event) => {
    event.persist();

    setFormState((prevFormState) => ({
      ...prevFormState,
      values: {
        ...prevFormState.values,
        [event.target.name]:
          event.target.type === "checkbox"
            ? event.target.checked
            : event.target.value,
      },
      touched: {
        ...prevFormState.touched,
        [event.target.name]: true,
      },
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { userName, password } = formState.values;

    onSubmit(userName, password);

  };

  const handleForgot = () => {
    onForgot(true);
  };

  const hasError = (field) =>
    !!(formState.touched[field] && formState.errors[field]);

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState((prevFormState) => ({
      ...prevFormState,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.values]);

  return (
    <form
      {...rest}
      className={clsx(classes.root, className)}
      onSubmit={handleSubmit}
    >
      <div className={classes.fields}>
        <TextField
          error={hasError("userName")}
          fullWidth
          helperText={
            hasError("userName") ? formState.errors.userName[0] : null
          }
          label={t("loginUserName")}
          name="userName"
          onChange={handleChange}
          value={formState.values.userName || ""}
          variant="outlined"
        />
        <TextField
          error={hasError("password")}
          fullWidth
          helperText={
            hasError("password") ? formState.errors.password[0] : null
          }
          label={t("loginPassword")}
          name="password"
          onChange={handleChange}
          type="password"
          value={formState.values.password || ""}
          variant="outlined"
        />
      </div>
      {option.isShowForgetPasswordVendor && (
        <div>
          <a href="#" className={classes.forGotPassword} onClick={handleForgot}>
            {t("loginForgotPassword")}
          </a>
        </div>
      )}
      {option.isShowForgetPasswordPTTGroup && (
        <>
          <br />
          <span> สามารถดำเนินการเปลี่ยนรหัสผ่านที่ระบบ GSS </span>
        </>
      )}
      <Button
        className={classes.submitButton}
        color="secondary"
        disabled={!formState.isValid}
        size="large"
        type="submit"
        variant="contained"
      >
        {t("loginButton")}
      </Button>
    </form>
  );
}

Login.propTypes = {
  className: PropTypes.string,
};

export default Login;
